import Actions from './chat-actions';
import reducer from './chat-reducer';
import Selectors from './chat-selectors';

export default {
  Actions,
  namespace: 'chat',
  reducer,
  Selectors,
};
